import {
  TransactionConfiguration,
  LimitTypeMappingConfiguration,
  JobDescriptionLimitMappingConfiguration,
  SocialNumberLimitMappingConfiguration,
  JobDescriptionLimitConfiguration,
  SocialNumberLimitConfiguration,
} from "src/app/ui/models/domains/pbm/Benefit/transaction-configuration";
import { Injectable } from "@angular/core";
import { AbstractParser } from "../../parser";
import { parseJobDescription } from "../beneficiary/beneficiary-parse-functions";

@Injectable()
export class TransactionConfigurationParser extends AbstractParser<TransactionConfiguration> {
  parse(payload: any): TransactionConfiguration {
    const transactionConfiguration = new TransactionConfiguration();
    transactionConfiguration.setKey(payload.Key);
    transactionConfiguration.setCompanyFiscalNumber(payload.CompanyFiscalNumber);
    transactionConfiguration.setLimitTypeMappingConfiguration(this.limitTypeMappingConfigurationParser(payload.LimitTypeMappingConfiguration));
    transactionConfiguration.setJobDescriptionLimitMappingConfiguration(
      this.jobDescriptionLimitMappingConfigurationParser(payload.JobDescriptionLimitMappingConfiguration),
    );
    transactionConfiguration.setSocialNumberLimitMappingConfiguration(
      this.socialNumberLimitMappingConfigurationParser(payload.BeneficiarySocialNumberLimitMappingConfiguration),
    );
    return transactionConfiguration;
  }

  private limitTypeMappingConfigurationParser(payload: any): LimitTypeMappingConfiguration {
    const limitTypeMappingConfiguration = new LimitTypeMappingConfiguration();
    limitTypeMappingConfiguration.setLimitType(payload.LimitType);
    limitTypeMappingConfiguration.setLimit(payload.Limit);
    limitTypeMappingConfiguration.setIsCashPurchase(payload.IsCashPurchase);
    return limitTypeMappingConfiguration;
  }

  private jobDescriptionLimitMappingConfigurationParser(payload: any): JobDescriptionLimitMappingConfiguration {
    const jobDescriptionLimitMappingConfiguration = new JobDescriptionLimitMappingConfiguration();
    jobDescriptionLimitMappingConfiguration.setJobDescriptionLimits(this.jobDescriptionLimitsParser(payload.JobPositionConfigurations));
    return jobDescriptionLimitMappingConfiguration;
  }

  private jobDescriptionLimitsParser(payload: any): JobDescriptionLimitConfiguration[] {
    return payload.map((item) => {
      const jobDescriptionLimitConfiguration = new JobDescriptionLimitConfiguration();
      jobDescriptionLimitConfiguration.setJobDescription(parseJobDescription(item.JobDescription));
      jobDescriptionLimitConfiguration.setLimit(item.Limit);
      jobDescriptionLimitConfiguration.setIsUnlimited(item.Unlimited);
      jobDescriptionLimitConfiguration.setInUse(item.InUse);
      return jobDescriptionLimitConfiguration;
    });
  }

  private socialNumberLimitMappingConfigurationParser(payload: any): SocialNumberLimitMappingConfiguration {
    const socialNumberLimitMappingConfiguration = new SocialNumberLimitMappingConfiguration();
    socialNumberLimitMappingConfiguration.setSocialNumberLimits(this.socialNumberLimitsParser(payload.BeneficiarySocialNumberLimitConfigurations));
    return socialNumberLimitMappingConfiguration;
  }

  private socialNumberLimitsParser(payload: any): SocialNumberLimitConfiguration[] {
    return payload.map((item) => {
      const socialNumberLimitConfiguration = new SocialNumberLimitConfiguration();
      socialNumberLimitConfiguration.setName(item.Name);
      socialNumberLimitConfiguration.setSocialNumber(item.SocialNumber.Value);
      socialNumberLimitConfiguration.setLimit(item.Limit);
      socialNumberLimitConfiguration.setIsUnlimited(item.Unlimited);
      return socialNumberLimitConfiguration;
    });
  }
}
